import { ButtonPrimeReact } from "@finanedi.es/storybook"
// @ts-expect-error TS(2307): Cannot find module 'assets/plantillas_excel/planti...
import plantillaContactos from "assets/plantillas_excel/plantilla_importar_contactos.xlsx"
import CustomButton from "common/components/Button/Button"
import Dropzone from "common/components/Dropzone"
import ImportGrid from "common/components/ImportGrid"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import useImportGrid from "common/hooks/useImportGrid"
import ContactosService from "common/services/ContactosService"
import { mapContactosToPostContactosUpdated } from "common/utils/mappers"
import notification from "common/utils/notification"
import { checkDocumentFormat } from "features/User/utils"
import { Message } from "primereact/message"
import { useTranslation } from "react-i18next"
import { OPTIONS_CONTACTOS } from "../../constants"

const ImportarContactos = () => {
  const { t } = useTranslation()
  const {
    header,
    setData,
    data,
    selectedOptions,
    fetching,
    handleSetData,
    setSelectedOptions,
    handleUpload,
  } = useImportGrid({ options: OPTIONS_CONTACTOS })

  const { handleDownloadFile } = useDownloadFileContext()

  const handleOnDrop = async (files: $TSMigrationFixMe) => {
    checkDocumentFormat(files?.length, files[0], handleSetData)
  }

  const handleDownload = () => {
    handleDownloadFile(plantillaContactos, "Plantilla_contactos.xlsx")
  }

  const handleImportarContactos = async () => {
    const ok = await handleUpload((data: $TSMigrationFixMe) => {
      return ContactosService.postContactos(
        mapContactosToPostContactosUpdated(data)
      )
    })

    if (ok) {
      notification.success({
        body: `${t("importar.contactos.msg.correctImport")}`,
      })
    }
  }

  return (
    <div className='d-flex- justify-content-center h-100 import-scroller-page'>
      <p
        className='text-left text-gedesco'
        style={{ fontSize: "21px" }}
      >
        {t("importar.contactos.title")}
      </p>

      <div className='mb-3 d-flex justify-content-between'>
        <Message
          className='w-75'
          severity='info'
          text={`${t("importar.contactos.msgTemplate")}`}
        />
        <CustomButton
          className='!tw-bg-primary'
          onClick={handleDownload}
        >
          {t("importar.contactos.downloadTemplate")}
        </CustomButton>
      </div>

      <Dropzone
        maxFiles={1}
        onDrop={handleOnDrop}
        acceptLabel='.xlsx'
        accept='.xlsx'
        fluid
      />

      <ImportGrid
        data={data}
        setData={setData}
        header={header}
        options={OPTIONS_CONTACTOS}
        dropdownStates={selectedOptions}
        setDropdownStates={setSelectedOptions}
      />

      <div className='my-3 mr-1 d-flex justify-content-end'>
        {data.length ? (
          <ButtonPrimeReact
            loading={fetching}
            onClick={handleImportarContactos}
            className='!tw-bg-primary !tw-border-none tw-text-simple-10'
          >
            {t("importar.contactos.importButton")}
          </ButtonPrimeReact>
        ) : null}
      </div>
    </div>
  )
}

export default ImportarContactos
